import {coreRoutes} from '@sttedra_ui/framework';

export default [
  ...coreRoutes,
];
